import axios from 'axios';

import {
  EnhetLookupConfirmResult,
  EnhetLookupContext,
  EnhetLookupStepName,
  LookupCandidate,
} from './types';

import { getKjederegAdminApiUrl } from '../../';

const baseUrl = getKjederegAdminApiUrl() + '/EnhetMatchLookup';

async function findCandidates(
  stepName: EnhetLookupStepName,
  context: EnhetLookupContext,
): Promise<LookupCandidate[]> {
  const response = await axios.post<LookupCandidate[]>(
    `${baseUrl}/${stepName}/candidates`,
    context,
  );
  return response.data;
}

async function confirm(
  stepName: EnhetLookupStepName,
  context: EnhetLookupContext,
  candidateId: string,
): Promise<EnhetLookupConfirmResult> {
  const response = await axios.post<EnhetLookupConfirmResult>(`${baseUrl}/${stepName}/confirm`, {
    context,
    candidateId,
  });
  return response.data;
}

export default {
  findCandidates,
  confirm,
};
